export default {"src":"/_next/static/media/closeIcon.f2d9ed3d.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};